import { MutableRefObject, useCallback } from 'react';
import { useCompareDeps } from '@theme/js/hooks/swiss/useCompareDeps';

export const useClassRemove = <T extends HTMLElement>(
    classToRemove: string = '',
    refs: MutableRefObject<T | null>[],
    shouldRemove = true
) => {
    const handleRemoveClassCb = useCallback(() => {
        if (classToRemove && refs.length && shouldRemove) {
            refs.forEach(ref => {
                if (ref.current) {
                    ref.current.classList.remove(classToRemove);
                }
            });
        }
    }, useCompareDeps([classToRemove, refs, shouldRemove]));

    return handleRemoveClassCb;
};
